module.exports = __webpack_public_path__ + "static/media/gif-app.4d66479d.jpg";